import { useEffect, useState } from "react";
import styles from "./EsmaBoxes.module.scss";
import { getStockShortEsmaSummary } from "@/controllers/stock-shorts";
import { Stock } from "@/models/stock";
import { nFormatter } from "@/lib/utils";
import { EsmaPosition } from "@/models/stock-shorts";
import { Chip, Typography } from "@mui/material";

type Props = {
    stock: Stock;
};

const EsmaBoxes = ({ stock }: Props) => {
    const [data, setData] = useState<Array<EsmaPosition>>([]);

    const CHIP_STYLES = {
        padding: 2.5,
        "@media screen and (min-width: 3840px)": {
            padding: 4,
        },
    };

    useEffect(() => {
        getStockShortEsmaSummary(stock.tradingitem_id).then((data) => setData(data));
    }, [stock]);

    return (
        <div className={styles.EsmaBoxes}>
            <div className={styles.wrapper}>
                {data.map((box) => {
                    const { format, key, name, value } = box;
                    return (
                        <div className={styles.box} key={key}>
                            <Chip
                                sx={{ ...CHIP_STYLES }}
                                label={
                                    <div>
                                        <Typography variant="body2" className={styles.title}>
                                            {name}
                                        </Typography>
                                        <Typography variant="body1" className={styles.value}>
                                            {format === "millify" ? `${nFormatter(value as number)}` : `${typeof value === "number" ? (value.toFixed(2) as any) : "N/A"}%`}
                                        </Typography>
                                    </div>
                                }
                                variant="outlined"
                                size="small"
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default EsmaBoxes;
